import { Checkbox, Divider, Drawer, Select, Slider } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { tt_name_block_warning } from "../../../utils/Utils";
import SliderInput from "../../UI/SiderInput";
import BMInput from "../../comps/BMInput";

export default function BlankSpace(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);
    const [template,] = useTemplate();

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        height = 30,
        background_colour = 0,
        divider = false,
        divider_height = 1,
        divider_colour = 0,
        divider_style = "solid", // dots, dashes
        divider_width = 100,

    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {
        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div className="shim" style={{ "display": "flex", "flexDirection": "column", "justifyContent": "space-evenly", "height": height + "px", "background": getColor(background_colour, template) }}>
                    {(divider && <div style={{ "margin": "0 auto", "width": divider_width + "%", "height": "0px", "borderTop": divider_height + "px " + divider_style + " " + getColor(divider_colour, template, "#000") }} />)}
                </div>
            </div>
        )
    }

    const marks = {
        10: <small>10px</small>,
        30: <small>30px</small>,
        60: <small>60px</small>,
        100: <small>100px</small>,
    };

    const formatter = (value) => `${value}%`;

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                {/* HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEIGHT</Divider>
                <Slider defaultValue={height} onChange={(e) => setData({ ...data, "height": e })} marks={marks} min={1} max={120} />
                {/* BACKGROUND IMAGE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* MAX WIDTH */}

                <Checkbox onChange={(e) => setData({ ...data, "divider": e.target.checked })} checked={divider}><small>Divider?</small></Checkbox>
                <div className="shim" /> <div className="shim" /><div className="shim" /> <div className="shim" />

                {/* IMAGE WIDTH / HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WIDTH</Divider>
                <div className="float-flex">
                    <Slider
                        tooltip={{
                            formatter,
                        }}
                        style={{ "width": "100%" }}
                        min={0}
                        max={100}
                        onChange={(_v) => setData({ ...data, "divider_width": _v })}
                        value={divider_width}
                    />
                </div>
                <div className="shim" /><div className="shim" />


                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEIGHT / STYLE</Divider>

                <div className="float-flex">
                    <BMInput disabled={!divider} value={divider_height} onChange={(_v) => setData({ ...data, "divider_height": _v })} number min={1} max={20} prefix={<nobr>HEIGHT</nobr>} />
                    <Select disabled={!divider} value={divider_style} onChange={(e) => setData({ ...data, "divider_style": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%", "fontSize": "11px" }} bordered={true}>
                        <Select.Option key={"solid"} value={"solid"}>Solid</Select.Option>
                        <Select.Option key={"dashed"} value={"dashed"}>Dashed</Select.Option>
                        <Select.Option key={"dotted"} value={"dotted"}>Dots</Select.Option>
                    </Select>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND IMAGE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DIVIDER COLOUR</Divider>
                <ColourPicker disabled={!divider} allow_gradient allow_none value={divider_colour} onChange={(_v) => setData({ ...data, "divider_colour": _v })} />
                <div className="shim" /> <div className="shim" />

            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}